// NOTE: Values manually added
export const fontWeights = {
	normal: 425,
	medium: 500,
	semibold: 600,
	extrabold: 800,
};
